import { Checkbox } from '@/ui/Checkbox'

import styles from './LowBridgeWarning.module.scss'

import BridgeIcon from '../../../../assets/bridge.svg'

interface Props {
    onChange: (checked: boolean) => void
}

export const LowBridgeWarning = ({ onChange }: Props) => (
    <div className={styles.root}>
        <div className={styles.titleWrapper}>
            <BridgeIcon />
            <p className={styles.title}>Caution - low bridge</p>
        </div>
        <p className={styles.text}>There is a low bridge nearby. Please check before advising drivers.</p>
        <div className={styles.checkboxWrapper}>
            <Checkbox onChange={onChange} label={'I have informed the driver of the low bridge'}/>
        </div>
    </div>
)
